		import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSetTable } from "../InfoSets/InfoSetTable";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { StringUtils } from "../Utils/StringUtils";
import { Device } from "../Core/Device";
import { HashSet } from "../Utils/HashSet";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

  //export interface IpRouteInfoJson {
  //  ip_route_table: any;
  //  ip_forwarding: string;
  //  ip_v6_forwarding: string;
  //}

  //export interface IpRouteEntryJson {
  //  route_destination:string;
  //  route_if_index: string;
  //  route_next_hop: string;
  //  route_type: string;
  //  route_protocol: string;
  //  route_mask: string;
  //  route_is_cidr: string;
  //}

export class IpRouteEntry /*implements ISerializable*/ implements ObjectSerializer {
    public static ipRouteType_unknown = 0;
    public static ipRouteType_other = 1;
    public static ipRouteType_invalid = 2;
    public static ipRouteType_direct = 3;
    public static ipRouteType_indirect = 4;
    public static ipCidrRouteType_unknown = 0;
    public static ipCidrRouteType_other = 1;
    public static ipCidrRouteType_reject = 2;
    public static ipCidrRouteType_local = 3;
    public static ipCidrRouteType_remote = 4;
    public static ipRouteProto_unknown = 0;
    public static ipRouteProto_other = 1;   // 
    public static ipRouteProto_local = 2;   // 
    public static ipRouteProto_netmgmt = 3; // 
    public static ipRouteProto_icmp = 4;    // 
    public static ipRouteProto_egp = 5;
    public static ipRouteProto_ggp = 6;
    public static ipRouteProto_hello = 7;
    public static ipRouteProto_rip = 8;
    public static ipRouteProto_isIs = 9;
    public static ipRouteProto_esIs = 10;
    public static ipRouteProto_ciscoIgrp = 11;
    public static ipRouteProto_bbnSpfIgp = 12;
    public static ipRouteProto_ospf = 13;
    public static ipRouteProto_bgp = 14;
    public static ipRouteProto_idpr = 15;
    public static ipRouteProto_ciscoEigrp = 16;
    public static ipRouteProto_dvmrp = 17;

    public RouteDest: IpAddress;

    public RouteIfIndex: number;

    public get HasRouteIfIndex(): boolean {
      return this.RouteIfIndex >= 0;
    }

    public RouteNextHop: IpAddress;
    public get HasRouteNextHop(): boolean {
      return !!this.RouteNextHop;
    }

    public RouteType: number;
    public RouteTypeToString(): string {
      var routeType = StringUtils.Empty;

      if (this.IsCidrRoute) {
        switch (this.RouteType) {
          case IpRouteEntry.ipCidrRouteType_unknown: routeType = "unknown"; break;
          case IpRouteEntry.ipCidrRouteType_other: routeType = "other"; break;
          case IpRouteEntry.ipCidrRouteType_reject: routeType = "reject"; break;
          case IpRouteEntry.ipCidrRouteType_local: routeType = "local"; break;
          case IpRouteEntry.ipCidrRouteType_remote: routeType = "remote"; break;

          default: routeType = "unknown"; break;
        }
      }
      else {
        switch (this.RouteType) {
          case IpRouteEntry.ipRouteType_unknown: routeType = "unknown"; break;
          case IpRouteEntry.ipRouteType_other: routeType = "other"; break;
          case IpRouteEntry.ipRouteType_invalid: routeType = "invalid"; break;
          case IpRouteEntry.ipRouteType_direct: routeType = "direct"; break;
          case IpRouteEntry.ipRouteType_indirect: routeType = "indirect"; break;

          default: routeType = "unknown"; break;
        }
      }

      return (routeType);
    }
    public static GetRouteTypeFromString(routeTypeString: string): number {
      var routeType: number = IpRouteEntry.ipRouteType_unknown;

      if (!StringUtils.IsNullOrEmpty(routeTypeString))
        routeType = IpRouteEntry.ipRouteType_other;

      var lowerString: string = routeTypeString.toLowerCase();
      switch (lowerString) {
        case "unknown": routeType = IpRouteEntry.ipRouteType_unknown; break;
        case "other": routeType = IpRouteEntry.ipRouteType_other; break;
        case "invalid": routeType = IpRouteEntry.ipRouteType_invalid; break;
        case "direct": routeType = IpRouteEntry.ipRouteType_direct; break;
        case "indirect": routeType = IpRouteEntry.ipRouteType_indirect; break;
      }

      return routeType;
    }

    public RouteProto: number;
    public RouteProtoToString(): string {
      var routeProto: string = StringUtils.Empty;

      switch (this.RouteProto) {
        case IpRouteEntry.ipRouteProto_other: routeProto = "other"; break;
        case IpRouteEntry.ipRouteProto_local: routeProto = "local"; break;
        case IpRouteEntry.ipRouteProto_netmgmt: routeProto = "netmgmt"; break;
        case IpRouteEntry.ipRouteProto_icmp: routeProto = "icmp"; break;
        case IpRouteEntry.ipRouteProto_egp: routeProto = "egp"; break;
        case IpRouteEntry.ipRouteProto_ggp: routeProto = "ggp"; break;
        case IpRouteEntry.ipRouteProto_hello: routeProto = "hello"; break;
        case IpRouteEntry.ipRouteProto_rip: routeProto = "rip"; break;
        case IpRouteEntry.ipRouteProto_isIs: routeProto = "isIs"; break;
        case IpRouteEntry.ipRouteProto_esIs: routeProto = "esIs"; break;
        case IpRouteEntry.ipRouteProto_ciscoIgrp: routeProto = "ciscoIgrp"; break;
        case IpRouteEntry.ipRouteProto_bbnSpfIgp: routeProto = "bbnSpfIgp"; break;
        case IpRouteEntry.ipRouteProto_ospf: routeProto = "ospf"; break;
        case IpRouteEntry.ipRouteProto_bgp: routeProto = "bgp"; break;
        case IpRouteEntry.ipRouteProto_idpr: routeProto = "idpr"; break;
        case IpRouteEntry.ipRouteProto_ciscoEigrp: routeProto = "ciscoEigrp"; break;
        case IpRouteEntry.ipRouteProto_dvmrp: routeProto = "dvmrp"; break;

        default: routeProto = "unknown"; break;
      }

      return (routeProto);
    }
    public static GetRouteProtoFromString(routeProtoString: string): number {
      var routeProto: number = IpRouteEntry.ipRouteProto_unknown;

      if (!StringUtils.IsNullOrEmpty(routeProtoString))
        routeProto = IpRouteEntry.ipRouteProto_other;

      var lowerString: string = routeProtoString.toLowerCase();
      switch (lowerString) {
        case "other": routeProto = IpRouteEntry.ipRouteProto_other; break;
        case "local": routeProto = IpRouteEntry.ipRouteProto_local; break;
        case "netmgmt": routeProto = IpRouteEntry.ipRouteProto_netmgmt; break;
        case "icmp": routeProto = IpRouteEntry.ipRouteProto_icmp; break;
        case "egp": routeProto = IpRouteEntry.ipRouteProto_egp; break;
        case "ggp": routeProto = IpRouteEntry.ipRouteProto_ggp; break;
        case "hello": routeProto = IpRouteEntry.ipRouteProto_hello; break;
        case "rip": routeProto = IpRouteEntry.ipRouteProto_rip; break;
        case "isIs": routeProto = IpRouteEntry.ipRouteProto_isIs; break;
        case "esIs": routeProto = IpRouteEntry.ipRouteProto_esIs; break;
        case "ciscoIgrp": routeProto = IpRouteEntry.ipRouteProto_ciscoIgrp; break;
        case "bbnSpfIgp": routeProto = IpRouteEntry.ipRouteProto_bbnSpfIgp; break;
        case "ospf": routeProto = IpRouteEntry.ipRouteProto_ospf; break;
        case "bgp": routeProto = IpRouteEntry.ipRouteProto_bgp; break;
        case "idpr": routeProto = IpRouteEntry.ipRouteProto_idpr; break;
        case "ciscoEigrp": routeProto = IpRouteEntry.ipRouteProto_ciscoEigrp; break;
        case "dvmrp": routeProto = IpRouteEntry.ipRouteProto_dvmrp; break;
      }

      return (routeProto);
    }

    // IPv4
    public RouteMask: IpAddress;
    public get HasRouteMask(): boolean {
      return this.RouteMask != null;
    }

    public IsCidrRoute: boolean;

    public RoutePrefixLength: number;
    public get HasRoutePrefixLength(): boolean {
      return this.RoutePrefixLength >= 0;
    }

    public RouteIndex: number;
    public get HasRouteIndex(): boolean {
      return this.RouteIndex >= 0;
    }

    constructor(ipRouteDest?: IpAddress) {
      this.Init();
      this.RouteDest = ipRouteDest;
    }

    private Init(): void {
      this.RouteIfIndex = -1;
      this.RouteNextHop = null;
      this.RouteType = IpRouteEntry.ipRouteType_unknown;
      this.RouteProto = IpRouteEntry.ipRouteProto_unknown;
      this.RouteMask = null;
      this.IsCidrRoute = false;

      // IPv6
      this.RoutePrefixLength = -1;
      this.RouteIndex = -1;
    }

    //public Deserialize(json: IpRouteEntryJson): void {
    //  if (json.route_destination !== undefined)
    //    this.RouteDest = IpAddress.Create(json.route_destination);

    //  if (json.route_if_index !== undefined)
    //    this.RouteIfIndex = parseInt(json.route_if_index);

    //  if (json.route_next_hop !== undefined)
    //    this.RouteNextHop = IpAddress.Create(json.route_next_hop);

    //  if (json.route_type !== undefined)
    //    this.RouteType = parseInt(json.route_type);

    //  if (json.route_protocol !== undefined)
    //    this.RouteProto = parseInt(json.route_protocol);

    //  if (json.route_mask !== undefined)
    //    this.RouteMask = IpAddress.Create(json.route_mask);

    //  if (json.route_is_cidr !== undefined)
    //    this.IsCidrRoute = StringUtils.ParseBool(json.route_is_cidr);
    //}

	public Write(obj: any, context: any): void {
		obj.ip_route_entry = {};
		obj = obj.ip_route_entry;

		obj.route_destination = ValueEncoder.EncodeIpAddress(this.RouteDest);

		if (this.HasRouteIfIndex)
			obj.route_if_index = ValueEncoder.EncodeInteger(this.RouteIfIndex);

		if (this.HasRouteNextHop)
			obj.route_next_hop = ValueEncoder.EncodeIpAddress(this.RouteNextHop);

		obj.route_type = ValueEncoder.EncodeInteger(this.RouteType);
		obj.route_protocol = ValueEncoder.EncodeInteger(this.RouteProto);

		if (this.HasRouteMask)
			obj.route_mask = ValueEncoder.EncodeIpAddress(this.RouteMask);

		obj.route_is_cidr = ValueEncoder.EncodeBoolean(this.IsCidrRoute);

		if (this.HasRoutePrefixLength)
			obj.route_prefix_length = ValueEncoder.EncodeInteger(this.RoutePrefixLength);

		if (this.HasRouteIndex)
			obj.route_index = ValueEncoder.EncodeInteger(this.RouteIndex);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_route_entry)
			throw new Error();
		obj = obj.ip_route_entry;

		if (obj.route_destination !== undefined)
			this.RouteDest = ValueEncoder.DecodeIpAddress(obj.route_destination);

		if (obj.route_if_index !== undefined)
			this.RouteIfIndex = ValueEncoder.DecodeInteger(obj.route_if_index);

		if (obj.route_next_hop !== undefined)
			this.RouteNextHop = ValueEncoder.DecodeIpAddress(obj.route_next_hop);

		if (obj.route_type !== undefined)
			this.RouteType = ValueEncoder.DecodeInteger(obj.route_type);

		if (obj.route_protocol !== undefined)
			this.RouteProto = ValueEncoder.DecodeInteger(obj.route_protocol);

		if (obj.route_mask !== undefined)
			this.RouteMask = ValueEncoder.DecodeIpAddress(obj.route_mask);

		if (obj.route_is_cidr !== undefined)
			this.IsCidrRoute = ValueEncoder.DecodeBoolean(obj.route_is_cidr);

		if (obj.route_prefix_length !== undefined)
			this.RoutePrefixLength = ValueEncoder.DecodeInteger(obj.route_prefix_length);

		if (obj.route_index !== undefined)
			this.RouteIndex = ValueEncoder.DecodeInteger(obj.route_index);
	}
}


  export class IpRouteTable extends InfoSetTable<IpAddress, IpRouteEntry> {
    public IsIpForwarding: boolean;
    public IsIpV6Forwarding: boolean;

    constructor(device: Device) {
      super(device);
      this.IsIpForwarding = false;
      this.IsIpV6Forwarding = false;
    }

    public Add(ipRouteDest: IpAddress): IpRouteEntry {
      var ipRouteEntry: IpRouteEntry = null;

      if (this._table.ContainsKey(ipRouteDest)) {
        ipRouteEntry = this._table.Item(ipRouteDest);
      }
      else {
        ipRouteEntry = new IpRouteEntry(ipRouteDest);
        this._table.Add(ipRouteDest, ipRouteEntry);
      }

      return (ipRouteEntry);
    }

    public AddEntry(ipRouteEntry: IpRouteEntry): boolean {

      if (ipRouteEntry == null)
        return false;

      if (this._table.ContainsKey(ipRouteEntry.RouteDest))
        return false;

      this._table.Add(ipRouteEntry.RouteDest, ipRouteEntry);
      return true;
    }

    public get HasIpSightings(): boolean {
      return true;
    }

    public get IpSightings(): HashSet<IpAddress> {
      var ipAddresses = new HashSet<IpAddress>();

      this._table.ForEach((pair) => {
        if (!pair.Value.HasRouteNextHop)
          return;
        if (!pair.Value.RouteNextHop.IsValidDiscoveryAddress)
          return;

        ipAddresses.Add(pair.Value.RouteNextHop);
      });

      return (ipAddresses);
    }

    //public Deserialize(json: IpRouteInfoJson): void {
    //  this.Clear();

    //  if (json.ip_forwarding !== undefined)
    //    this.IsIpForwarding = StringUtils.ParseBool(json.ip_forwarding);

    //  if (json.ip_v6_forwarding !== undefined)
    //    this.IsIpV6Forwarding = StringUtils.ParseBool(json.ip_v6_forwarding);

    //  if (json.ip_route_table !== undefined) {
    //    json.ip_route_table.forEach((entry:any) => {
    //      this.DeserializeEntry(entry[this.EntryName()]);
    //    });
    //  }
    //}

    //public DeserializeEntry(json: any): void {
    //  var entry = new IpRouteEntry(null);
    //  entry.Deserialize(json);
    //  this.AddEntry(entry);
    //}

    //public EntryName(): string {
    //  return "ip_route_entry";
    //};

    //public static FromJson(json: any, device: Device): IpRouteTable {
    //  var result = new IpRouteTable(device);
    //  result.Deserialize(json);
    //  return result;
    //}

	public Write(obj: any, context: any): void {
		obj.ip_route_info = {};
		obj = obj.ip_route_info;

		obj.ip_forwarding = ValueEncoder.EncodeBoolean(this.IsIpForwarding);
		obj.ip_v6_forwarding = ValueEncoder.EncodeBoolean(this.IsIpV6Forwarding);

		obj.ip_route_table = [];
		ObjSerUtils.WriteObjSerCollection(obj.ip_route_table, this._table.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.ip_route_info)
			throw new Error();
		obj = obj.ip_route_info;

		this.Clear();

		if (obj.ip_forwarding !== undefined)
			this.IsIpForwarding = ValueEncoder.DecodeBoolean(obj.ip_forwarding);

		if (obj.ip_v6_forwarding !== undefined)
			this.IsIpV6Forwarding = ValueEncoder.DecodeBoolean(obj.ip_v6_forwarding);

		if (obj.ip_route_table !== undefined) {
			obj.ip_route_table	.forEach((value: any) => {
				let entry = new IpRouteEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}
}
